// extracted by mini-css-extract-plugin
export default {"form":"SignUpPageForm_form__qWEDg"};